<template>
    <div class="container">
        <div v-for="(item, key) in articles" :key="key">
            <component :is="item" :asThumb="asThumb" :ref="item" v-if="current === item || asThumb" @open="open(item)"
                       @back="back()"/>
        </div>
    </div>
</template>

<script>
  export default {
    name: "Blog",
    components: {
      Article1: () => import('@/components/Blogs/BlogArticle1'),
      Article2: () => import('@/components/Blogs/BlogArticle2'),
      Article3: () => import('@/components/Blogs/BlogArticle3')
    },
    data () {
      return {
        articles: [
          'Article1',
          'Article2',
          'Article3'
        ],
        current: null,
        asThumb: true
      }
    },
    created () {
      this.init(this.$route.query.article)
    },
    watch: {
      '$route' (to) {
        this.init(to.query.article)
      }
    },
    methods: {
      open (item) {
        this.current = item;
        this.asThumb = false;
        this.$router.push({
          path: this.$router.path,
          query: {article: item},
        });
      },
      back () {
        this.current = null;
        this.asThumb = true;
        this.$router.push({
          path: this.$router.path,
        });
      },
      init(article) {
        this.asThumb = true
        this.current = null
        if (article !== undefined) {
          if (this.articles.includes(article)) {
            this.asThumb = false;
            this.current = this.$route.query.article;
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
